import { useMemo } from "react";

const usePromptRequestData = (requestsForPrompt: any, pageSize: number) => {
  return useMemo(() => {
    if (!requestsForPrompt?.data) {
      return {
        items: [],
        has_next: false,
        has_prev: false,
        pages: 0,
        page: 1,
        per_page: pageSize,
      };
    }

    return {
      ...requestsForPrompt.data,
      items: requestsForPrompt.data.items?.map((item: any) => {
        const defaultScore = item.scores?.find(
          (score: any) => score.default !== undefined,
        );
        const otherScores =
          item.scores
            ?.filter((score: any) => !("default" in score))
            .reduce((acc: any, score: any) => ({ ...acc, ...score }), {}) || {};

        return {
          ...item,
          score: {
            default: defaultScore?.default || null,
            others: otherScores,
          },
        };
      }),
    };
  }, [requestsForPrompt.data, pageSize]);
};

export default usePromptRequestData;
